var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"token-screen",attrs:{"loading":_vm.loading}},[_c('h1',[_vm._v("this is the token page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }